export const menuBulkActionsStyle = theme => ({
    button: {
        backgroundColor: "#E8E8E8",
        padding: "0px 8px",
        borderRadius: "4px",
        margin: "0px 8px",
    },
});